import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=828bd442&scoped=true&"
import script from "./SelectInput.vue?vue&type=script&lang=ts&"
export * from "./SelectInput.vue?vue&type=script&lang=ts&"
import style0 from "./SelectInput.vue?vue&type=style&index=0&id=828bd442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828bd442",
  null
  
)

export default component.exports